[
  {
    "question": "What is Toile?",
    "answer": "Toile is a free AI image generator built as an endless wall of pictures. Instead of writing prompts, you start from any picture on the wall — or from nothing — and change it with a few words."
  },
  {
    "question": "Is Toile free?",
    "answer": "Browsing and searching the wall is free with no account. Generating your own pictures is free with a sign-in."
  },
  {
    "question": "Do I need to know prompt engineering?",
    "answer": "No. Every picture on the wall already carries a full recipe. You only say what should change, in your own words and language — Toile rewrites the recipe for you."
  },
  {
    "question": "What kinds of images can I make?",
    "answer": "Coloring pages, wallpapers, sticker designs, logos, seamless patterns, invitation cards, tattoo designs, posters, product and food photography — and anything in between. If a style exists on the wall, you can make it yours."
  },
  {
    "question": "Can I change a picture after generating it?",
    "answer": "Yes — that is the point. Every generated picture can be taken further: add a direction to change one thing, or generate again for a fresh variation of the same idea."
  },
  {
    "question": "How do I find my own pictures again?",
    "answer": "Search the wall. Your own generations rank first for the words you used to make them, and your latest work sits on the tiles you started from."
  }
]
